import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-faq',
  templateUrl: './help-faq.component.html',
  styleUrls: ['./help-faq.component.scss']
})
export class HelpFaqComponent implements OnInit {

  helpFaq = [
    {
      name: 'FORMS',
      content: 'Content yet to be placed'
    },
    {
      name: 'LISTS',
      content: 'Content yet to be placed'
    },
    {
      name: 'EXPORTING',
      content: 'Content yet to be placed'
    },
    {
      name: 'DASHBOARD',
      content: 'Content yet to be placed'
    },
    {
      name: 'PROFILE',
      content: 'Content yet to be placed'
    },
    {
      name: 'THEME',
      content: 'Content yet to be placed'
    },
    {
      name: 'ACCOUNT',
      content: 'Content yet to be placed'
    }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
